<template>
<div class="top">
    <div class="title">{{ title }}</div>
    <div class="close" @click="close">
      <svg-icon icon-class="file-transfer-close"></svg-icon>
    </div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
export default {
  name: "test_vue",
  props: {
    isPreview: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  emits: ["closePreview", "closeSend"],
  components: {},
  data() {
    return {};
  },
  computed: {
    title() {
      return this.isPreview ? intl.$t("邮件预览#!!!#src/pages/H5/Cloud/components/email/EmailTop.vue_1") : intl.$t("邮件发送设置#!!!#src/pages/H5/Cloud/components/email/EmailTop.vue_1");
    }
  },
  methods: {
    close() {
      if (this.isPreview) {
        this.$emit("closePreview");
      } else {
        this.$emit("closeSend");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 48px;
  position: relative;

  .title {
    position: absolute;
    top: 24px;
    left: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000d9;
    line-height: 24px;
  }

  .close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    &:hover {
      background-color: #f4f6f9;
    }
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
